import { SxProps, Theme } from '@mui/material';

const nameGroup: SxProps<Theme> = {
  marginLeft: '15px',
  minWidth: 0
};

// nowrap plus no shrink keeps the column name intact and forces the
// generated-filter badge to give up space first.
const sortableName: SxProps<Theme> = {
  flexShrink: 0,
  whiteSpace: 'nowrap'
};

const name: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
  whiteSpace: 'nowrap'
};

export const tableHeaderSx = {
  nameGroup,
  sortableName,
  name
};
